import React, {useContext} from 'react';
import { Button, Select, MenuItem, FormControl, useMediaQuery } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FirstPageOutlinedIcon from '@material-ui/icons/FirstPageOutlined';
import LastPageOutlinedIcon from '@material-ui/icons/LastPageOutlined';
import { useListContext } from 'react-admin';
import { customTheme } from '../customTheme';
import { ContextProvider } from '../globalContextProvider';

const CustomPagination = ({setListData, trackUpdatedListData = false, CustomMsgComponent = false}) => {
    const { setSectionLoader } = useContext(ContextProvider);
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const { total, page, setPage, perPage, setPerPage, loading , data, currentSort, filterValues, basePath, resource} = useListContext();
    const nbPages = Math.ceil(total / perPage) || 1;

    const handleChange = (event) => {
        setPerPage(event.target.value)
    };

    setSectionLoader(loading)

    if(setListData && trackUpdatedListData){
        setListData({total, page, setPage, perPage, setPerPage, loading , data, currentSort, filterValues, basePath, resource})
    }
    else if(setListData && total !== 0){
        setListData({total, page, setPage, perPage, setPerPage, loading , data, currentSort, filterValues, basePath, resource})
    }

    return (
        total !== 0 ?
            <div className='customPagination' style={{ display: "flex", justifyContent: "flex-start", alignItems: "baseline", padding: isSmallDevice ? 0 : "2px 15px 4px 15px", marginBottom: isSmallDevice ? 30 : 0 }}>
                <p style={{ fontSize: 12, color: "#6a707e", fontWeight: "500", marginTop: 15, marginRight: 10, display: isSmallDevice ? "none" : "block" }}> Rows per page:</p>

                <FormControl variant="outlined" size="small">
                    <Select
                        value={perPage}
                        onChange={handleChange}
                        SelectDisplayProps={{ style: { padding: "5px 30px 5px 15px", fontSize: 12, border: "1px solid #c2cfe0", color: "#334d6e" } }}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                    </Select>
                </FormControl>


                <p style={{ fontSize: 12, color: "#6a707e", fontWeight: "500", marginLeft: 10 }}> {page === 1 ? page : page * perPage - perPage + 1} - {total < 10 || page === nbPages ? total : page * perPage} of {total}</p>


                <Button className="customStyleBtnP0" variant='outlined' style={{ height: "31px", margin: "8px 0px 0px 10px", color: page === 1 ? '#334d6e36' : '#334d6e' }} onClick={() => setPage(1)} disabled={page === 1}>
                    <FirstPageOutlinedIcon />
                </Button>
                <Button className="customStyleBtnP0" variant='outlined' style={{ height: "31px", margin: "8px 0px 0px 10px", color: page === 1 ? '#334d6e36' : '#334d6e' }} onClick={() => setPage(page - 1)} disabled={page === 1}>
                    <ChevronLeftIcon />
                </Button>


                <Button className="customStyleBtnP0" variant='outlined' style={{ height: "31px", margin: "8px 10px 0px 10px", color: page === nbPages ? '#334d6e36' : '#334d6e' }} onClick={() => setPage(page + 1)} disabled={page === nbPages}>
                    <ChevronRightIcon />
                </Button>
                <Button className="customStyleBtnP0" variant='outlined' style={{ height: "31px", margin: "8px 0px 0px 0px", color: page === nbPages ? '#334d6e36' : '#334d6e' }} onClick={() => setPage(Math.ceil(total / perPage))} disabled={page === nbPages}>
                    <LastPageOutlinedIcon />
                </Button>
            </div>
            : CustomMsgComponent ? <CustomMsgComponent/> : <div style={{ color: "#334D6E", fontSize: 12, fontFamily: "Poppins-Medium" , padding: "14px 20px 18px 20px"}}>No Result Found.</div>
    );
}

export default CustomPagination